import React, { useContext, useEffect, useState } from "react"
import AnnouncementHeader from "@components/Header/AnnouncementHeader"
import Cart from "@components/Cart"
import MenuBar from "@components/Header/MenuBar/MenuBar"
import Footer from "@components/Footer/Footer.jsx"
import LoginModal from "@components/modal/LoginModal"
import UserContext from "@context/UserContext"
import { StoreContext } from '@context/StoreContext'
import QuickBuyContext from "@context/QuickBuyContext"
import { sendGAEvent } from "@utils/analytics"
import { updateBuyersIdentity } from "@utils";

export const Layout = ({ 
	children, 
	gaEvent, 
	forceShowRegister = false, 
	footerMargin = "mt-20", 
	className = '', 
	disableDotDigitalPopOver = false, 
}) => {
	const { openLoginModal, setOpenLoginModal, user, token } = useContext(UserContext)
	const { checkout } = useContext(StoreContext)
	const { areHeaderMenusOpen } = useContext(QuickBuyContext)
	const [isMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : null)

	useEffect(() => {
		if (gaEvent) sendGAEvent(gaEvent?.eventName, gaEvent?.params)
	}, [])

	useEffect(() => {
		if(disableDotDigitalPopOver || process.env.GATSBY_STORE !== "PH") return
		
		/*** DOT DIGITAL POP-OVER SCRIPT ***/
		const script = document.createElement('script')
		const scriptSrc = isMobile
			? "//r3.dotdigital-pages.com/resources/sharing/popoverv2.js?sharing=lp-popover&domain=r3.dotdigital-pages.com&id=7R48-19A%2Fsummer-send-off-sale-mobile%22&delay=0&appearance=uc&mobile=&keydismiss=&width=600&description="
			: "//r3.dotdigital-pages.com/resources/sharing/popoverv2.js?sharing=lp-popover&domain=r3.dotdigital-pages.com&id=7R48-19B%2Fsummer-send-off-sale-desktop%22&delay=0&mobile=&keydismiss=&width=600&description="
		script.src = scriptSrc
		script.async = true
		document.body.appendChild(script)

		// Clean up by removing the script when the component unmounts
		return () => {
			document.body.removeChild(script)
		};
		/************** **** ***************/
	}, [isMobile])

	useEffect(() => {
		const checkBuysIdentity = async () => {
			if (checkout?.buyerIdentity?.email === null) {
				if (user?.email) {
					await updateBuyersIdentity(checkout?.id, token, user?.defaultAddress?.countryCodeV2);
				}
			}
		}

		checkBuysIdentity();

	}, [user, checkout])


	return (
		<React.Fragment>
			<main className={`font-sans ${className}`}>
				<Cart />
				<header className={`${areHeaderMenusOpen ? 'fixed w-full left-0' : 'sticky'} top-0 bg-white z-[51] shadow-sm`}>
					<AnnouncementHeader />
					<MenuBar />
				</header>
				{children}
				<Footer footerMargin={footerMargin} />

				<LoginModal
					showRegisterForm={forceShowRegister}
					isOpen={openLoginModal}
					onClose={() => {
						setOpenLoginModal(false)
					}}
				/>
			</main>
		</React.Fragment>
	)
}
